import {NgModule} from "@angular/core";
import {WebsitesRoutingModule} from "./websites-routing.module";
import {WebsitesComponent} from "./websites.component";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {SharedModule} from "../shared/shared.module";

@NgModule({
  declarations: [
    WebsitesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    WebsitesRoutingModule
  ],
  exports: [
    WebsitesComponent
  ],
  providers: []
})

export class WebsitesModule {}



// WEBPACK FOOTER //
// ./src/app/websites/websites.module.ts